import { FC, PropsWithChildren } from "react";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

import type { IAsset } from "@/api/IWalletController";

interface Props {
    date: number;
    from: IAsset;
    to: IAsset;
    fromAmount: number;
    toAmount: number;
}

const HistoryItem: FC<PropsWithChildren & Props> = ({ date, from, to, fromAmount, toAmount }) => {
    const formattedDate = format(new Date(date * 1000), "dd MMM, HH:mm");
    return (
        <li className="flex flex-col gap-2 py-4">
            <div className="flex justify-between items-center">
                <Badge className={"text-sm font-medium"} variant={"buy"}>
                    Sell
                </Badge>
                <time className="text-sm text-accent">{formattedDate}</time>
            </div>
            <div className="flex justify-start items-center gap-2">
                <span>
                    {fromAmount.toFixed(2)} {from.symbol}{from.name ? ` (${from.name})` : ""}
                </span>
                <img height={12} width={12} src="/images/sniper/right.svg" alt="" />
                <span>
                    {toAmount.toFixed(2)} {to.symbol}{to.name ? ` (${to.name})` : ""}
                </span>
            </div>
        </li>
    );
};

export default HistoryItem;
